var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"futureIT my-5"},[_c('sectionHeader',{staticClass:"py-3",attrs:{"text":_vm.header}}),_vm._v(" "),_c('sectionSummary',{attrs:{"text":_vm.summary}}),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12","md":"8","offset-md":"2"}},[_c('div',{staticClass:"text"},[_c('p',[_vm._v(_vm._s(_vm.text))])])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78bcb402","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/start/FutureIT.vue
// module id = null
// module chunks = 